export const RESOLUTION_ENDPOINTS = {
  base: '/resolutions',
  byId: (id: string) => `/resolutions/${id}`,
  entityLinks: (entityId: string) => `/resolutions/links/entity/${entityId}`,
  checkSimilarName: '/resolutions/check-similar-name',
};
